import {Component, inject} from '@angular/core';
import {EagleILayer} from '../../classes/eagle-i-layer';
import {SafetyZonesSource} from '../../sources/safety-zones-source';
import {forkJoin, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ApplicationConfig} from '../../../../classes/application-config';
import {FeatureCollection} from 'geojson';
import {LeafletLegendService} from '../../services/leaflet-legend.service';
import {catchError, map} from 'rxjs/operators';

@Component({
    selector: 'eaglei-safety-zones-layer',
    templateUrl: './safety-zones-layer.component.html',
    styleUrl: './safety-zones-layer.component.scss',
    standalone: false,
})
export class SafetyZonesLayerComponent extends EagleILayer<SafetyZonesSource> {
    public http = inject(HttpClient);
    public legendService = inject(LeafletLegendService);

    constructor() {
        super();
    }
    afterViewInit(): void {}

    toggleLayer(activeState: boolean): void {
        if (activeState) {
            if (!this.layerSource) {
                this.layerSource = new SafetyZonesSource(this.mapLayer);
            }
            this.getSafetyData();
        } else {
            this.layerSource.removeFromMap();
        }
    }

    getSafetyData() {
        const pointCall = this.http.get<FeatureCollection>(
            `${ApplicationConfig.proxyPrefix} + https://www.navcen.uscg.gov/sites/default/files/msi/safeZone_1.geojson`
        );
        const lineCall = this.http.get<FeatureCollection>(
            `${ApplicationConfig.proxyPrefix} + https://www.navcen.uscg.gov/sites/default/files/msi/safeZoneLine_1.geojson`
        );
        const polygonCall = this.http.get<FeatureCollection>(
            `${ApplicationConfig.proxyPrefix} + https://www.navcen.uscg.gov/sites/default/files/msi/safeZonePoly_1.geojson`
        );

        return forkJoin([pointCall, lineCall, polygonCall])
            .pipe(
                map((responses: [FeatureCollection, FeatureCollection, FeatureCollection]) => {
                    const allFeatures = [...responses[0].features, ...responses[1].features, ...responses[2].features];

                    return allFeatures;
                })
            )
            .subscribe((allFeatures) => {
                this.layerSource.processFeatures(allFeatures);
                this.layerSource.addToMap();
            });
    }
}
